import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { LogoSecondary } from 'src/common/assets'
import { PartnerRole, formatRequiredRolesMessage } from 'src/common/static'

const AccessDenied: React.FC = () => {
  const location = useLocation()
  const requiredRoles = (location.state as { requiredRoles?: PartnerRole[] } | null)?.requiredRoles ?? []
  const message = formatRequiredRolesMessage(requiredRoles)

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 150px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2
      }}
    >
      <LogoSecondary width={70} height={70} />
      <Typography variant="h3" fontWeight={700} m="40px 0 16px">
        Access denied
      </Typography>
      <Typography variant="h5" mb="16px">
        You don&apos;t have permission to view this page.
      </Typography>
      {message && (
        <Typography variant="body1" color="grey.600" mb="40px">
          {message}
        </Typography>
      )}
      <Button variant="contained" size="large" href="/" sx={{ mt: message ? 0 : '40px' }}>
        Back to Dashboard
      </Button>
    </Box>
  )
}

export default AccessDenied
